@if (show) {
  <div class="alert" [ngClass]="type">
    <div class="icon">
      @switch (type) {
        @case ("success") {
          <i class="fa-regular fa-circle-check"></i>
        }
        @case ("error") {
          <i class="fa-regular fa-circle-xmark"></i>
        }
        @case ("warning") {
          <i class="fa-solid fa-triangle-exclamation"></i>
        }
        @case ("info") {
          <i class="fa-solid fa-circle-info"></i>
        }
      }
    </div>
    <span class="alert-text">{{ message }}</span>
  </div>
}
